import React, { useEffect } from 'react';
import { DOM_IDS } from '../config';

const COMMENT_SDK_CSS_ID = 'comment-sdk-css';
const COMMENT_SDK_JS_ID = 'comment-sdk-js';

interface CommentsWidgetProps {
  slug: string;
}

const CommentsWidget: React.FC<CommentsWidgetProps> = ({ slug }) => {
  useEffect(() => {
    // Inject CSS once
    if (!document.getElementById(COMMENT_SDK_CSS_ID)) {
      const link = document.createElement('link');
      link.id = COMMENT_SDK_CSS_ID;
      link.rel = 'stylesheet';
      link.href = '/comment-sdk/comments-sdk.min.css';
      document.head.appendChild(link);
    }

    // Remove and re-inject script on each slug change to force SDK re-initialization
    const existingScript = document.getElementById(COMMENT_SDK_JS_ID);
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = COMMENT_SDK_JS_ID;
    script.src = '/comment-sdk/comments-sdk.min.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const s = document.getElementById(COMMENT_SDK_JS_ID);
      if (s) s.remove();
    };
  }, [slug]);

  return (
    <div id={DOM_IDS.COMMENTS_WIDGET} data-slug={slug} className="comments-section" data-theme="light" />
  );
};

export default CommentsWidget;